<div [class.is-personalized-layout]="!!layoutVars">
  @if (showTutorial) {
    <app-small-feature-announcement
      badgeText="NOVIDADE"
      featureKey="pricing-card-tour-v2"
      title="Aceita centavos"
      description="O campo precificar agora recebe valores com centavos."
    >
    </app-small-feature-announcement>
  }
  <div class="card card-offer-evaluation mb-3"
    [class.card-offer-evaluation--online]="isOnlineEvaluation()"
    [class.card-offer-evaluation--expected]="isExpectedPriceMode()">
    <div class="card-body">
      <div class="row box-input" *ngIf="!showGiveBack">
        <div class="col-md-12 value pricing-panel">
          <div class="pricing-header">
            <h3><i class="app-icon-tag"></i>PRECIFICAR</h3>
            @if (fipePrice > 0) {
            <app-fipe-comparison-badge
              variant="tag"
              accentColor="var(--pricing-accent)"
              [shortLabel]="true"
              [price]="price.value"
              [fipePrice]="fipePrice"
              [displayMode]="userInfo?.fipeComparisonMode"
              digits="1.1-1"
            />
            }
          </div>

          <mat-form-field class="pricing-main-field" [class.tutorial-highlight]="showTutorial">
            <span matPrefix class="currency-symbol">R$&nbsp;</span>
            <input [formControl]="price" matInput currencyMask [options]="{
                prefix: '',
                thousands: '.',
                precision: 2,
                allowNegative: false
              }" type="tel" (click)="initTutorial(); $event.stopPropagation()" (blur)="onPriceBlur()" />
            <mat-icon *ngIf="price.enabled" matSuffix>mode_edit</mat-icon>
          </mat-form-field>

          @if (priceFilledByCalculator || isCalculatorPaymentCeilingActive()) {
          <div class="pricing-calculator-hint">
            <i class="fa-solid fa-wand-magic-sparkles"></i>
            @if (isCalculatorPriceLocked()) {
              Preenchido pela calculadora — valor obrigatório
            } @else if (isCalculatorPaymentCeilingActive()) {
              Ajuste permitido até {{ calculatorPriceCeilingLabel() }}
            } @else {
              Preenchido pela calculadora — você pode ajustar
            }
          </div>
          }

          @if (isCalculatorPaymentCeilingActive() && price.hasError('max') && price.touched) {
          <div class="pricing-fipe-hint" role="status">
            <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
            O valor não pode ultrapassar {{ calculatorPriceCeilingLabel() }}.
          </div>
          }

          @if (fipeOutOfRangeAlertVisible) {
          <div class="pricing-fipe-hint" role="status">
            <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
            Valor fora da faixa esperada da FIPE. Confirme se está correto.
          </div>
          }

          <div class="small-form-field" *ngIf="showFactoryBonus">
            <label>Bônus de fábrica</label>
            <mat-form-field>
              <span matPrefix class="currency-symbol">R$&nbsp;</span>
              <input [formControl]="factoryBonus" matInput currencyMask [options]="{
                prefix: '',
                thousands: '.',
                precision: 0,
                allowNegative: false
              }" type="tel" (click)="$event.stopPropagation()" [disabled]="canEditFactoryBonus" />
              <mat-icon *ngIf="factoryBonus.enabled" matSuffix>mode_edit</mat-icon>
            </mat-form-field>
          </div>

          <ng-container *ngIf="shouldShowListMinPricesFields()">
            <div class="small-form-field">
              <label>Preço mínimo de venda <span *ngIf="userInfo?.requiredPricingFields" class="text-danger">*</span></label>
              <mat-form-field>
                <span matPrefix class="currency-symbol">R$&nbsp;</span>
                <input [formControl]="minSellPrice" matInput currencyMask [options]="{
              prefix: '',
              thousands: '.',
              precision: 0,
              allowNegative: false
            }" type="tel" (click)="$event.stopPropagation()" />
                <mat-icon *ngIf="minSellPrice.enabled" matSuffix>mode_edit</mat-icon>
              </mat-form-field>
            </div>

            <div class="small-form-field">
              <label>Preço para anúncio <span *ngIf="userInfo?.requiredPricingFields" class="text-danger">*</span></label>
              <mat-form-field>
                <span matPrefix class="currency-symbol">R$&nbsp;</span>
                <input [formControl]="listPrice" matInput currencyMask [options]="{
              prefix: '',
              thousands: '.',
              precision: 0,
              allowNegative: false
            }" type="tel" (click)="$event.stopPropagation()" />
                <mat-icon *ngIf="listPrice.enabled" matSuffix>mode_edit</mat-icon>
              </mat-form-field>
              @if (isListPriceMarginHintVisible()) {
                <div class="pricing-list-price-hint" role="note">
                  <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
                  Valor sugerido pela margem configurada. Se for editar manualmente, faça por último — alterar o preço sobrescreve este campo.
                </div>
              }
            </div>
          </ng-container>

          <!-- <div class="row" id="observations" *ngIf="canAddAndViewObservations()">
            <div class="col-12">
              <ng-container *ngIf="vehicle.commentsForPricing">
                <h3><span class="material-icons">
                    edit_note
                  </span>OBSERVAÇÕES</h3>
                <div class="observations-list-wrap">
                  <ul class="observation-list">
                    <li class="observation-item" *ngFor="let comment of vehicle.commentsForPricing">
                      <div class="obs-header d-flex align-items-center justify-content-between">
                        <div class="obs-name">
                          {{comment.username}}
                        </div>
                        <div class="obs-date">
                          {{comment.createdAt | date:'dd/MM/yyyy HH:mm'}}
                        </div>
                      </div>
                      <div class="obs-text">
                        {{comment.comment}}
                      </div>
                    </li>
                  </ul>
                </div>
              </ng-container>
              <div class="add-observation" (click)="obsModal = true">
                Incluir observações (privado para a mesa)
              </div>
              
              <div class="modal-backdrop fade in" [style.display]="obsModal ? 'block' : 'none'"></div>
              <div class="modal fade" [ngClass]="{'show': obsModal, 'hide': !obsModal}"
                [style.display]="obsModal ? 'block' : 'none'" (click)="closeObsModal()">
                <div class="modal-dialog modal-dialog-centered" (click)="(false); $event.stopPropagation()">
                  <div class="modal-content box-arrematar">
                    <div class="modal-header">
                      <div class="close-modal" (click)="closeObsModal()">
                        <span class="material-icons">close</span>
                      </div>
                    </div>
                    <div class="modal-body">
                      <h3>
                        <span class="material-icons">edit_note</span>
                        OBSERVAÇÕES
                      </h3>
                      <form class="obs-form mt-3">
                        <mat-form-field appearance="fill">
                          <mat-label>DEIXE UM COMENTÁRIOS</mat-label>
                          <textarea matInput name="obsMsg" [(ngModel)]="obsMsg"></textarea>
                        </mat-form-field>
                      </form>
                      <div class="d-flex flex-column align-items-center modal-send-area">
                        <button (click)="sendObs()" class="btn btn-primary btn-rounded block mb-3 w-100"
                          [disabled]="loadingBtn">
                          INCLUIR OBSERVAÇÃO
                        </button>
                        <a class="block" (click)="closeObsModal()">
                          CANCELAR
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->

          <div class="row pricing-destination-row" style="margin-bottom: 10px;">
            <div class="col-md-12">
              <mat-radio-group [formControl]="destination" style="color: white; width: 100%;"
                aria-label="Selecione uma opção">
                <mat-radio-button value="TRADE_IN" style="margin-right: 20px;">Repasse</mat-radio-button>
                <mat-radio-button value="SHOWROOM">Showroom</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <mat-checkbox [formControl]="addComment">Adicionar comentário para o vendedor</mat-checkbox>
            </div>
          </div>
          <textarea *ngIf="addComment.value" [formControl]="commentClosePricing" placeholder="COMENTÁRIOS"
            class="form-control" rows="10" style="resize: none;"></textarea>

          <div class="pricing-purpose" *ngIf="showPricingTypeSelector()">
            <div class="pricing-section-title">Finalidade da análise</div>
            <div class="pricing-type-panel" [class.pricing-type-panel--error]="pricingType.invalid && pricingType.touched">
              <div class="pricing-type-panel__options">
                <button type="button" class="pricing-type-option pricing-type-option--purchase"
                  [class.active]="pricingType.value === PricingFlowType.PURCHASE"
                  (click)="pricingType.setValue(PricingFlowType.PURCHASE)">
                  <span class="pricing-type-option__icon">
                    <i class="fa-solid fa-chart-line"></i>
                  </span>
                  <span>Precificação</span>
                </button>
                <button type="button" class="pricing-type-option pricing-type-option--expected"
                  [class.active]="pricingType.value === PricingFlowType.EXPECTED_PRICE"
                  (click)="pricingType.setValue(PricingFlowType.EXPECTED_PRICE)">
                  <span class="pricing-type-option__icon">
                    <i class="fa-solid fa-user-tag"></i>
                  </span>
                  <span>Expectativa</span>
                </button>
              </div>
            </div>
          </div>

          <div class="small-form-field" *ngIf="shouldShowEvaluatorField()">
            <label>AVALIADOR</label>
            <div class="evaluator-field-content">
              <mat-form-field>
                <mat-select [formControl]="evaluator" placeholder="Selecione um avaliador">
                  <mat-select-trigger>
                    {{ selectedEvaluatorName() }}
                    <span *ngIf="selectedEvaluatorHasNoCpf()"> — Sem CPF</span>
                  </mat-select-trigger>
                  <mat-option [value]="null">Não informar</mat-option>
                  <mat-option *ngFor="let option of evaluatorOptions" [value]="option.id">
                    {{ option.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-icon *ngIf="selectedEvaluatorHasNoCpf()"
                class="evaluator-info-icon"
                matTooltip="Sem CPF cadastrado — a integração com o DMS pode falhar">
                info_outline
              </mat-icon>
            </div>
          </div>

          <div class="pricing-warning" *ngIf="shouldShowArchiveWarning()">
            <i class="fa-solid fa-triangle-exclamation"></i>
            <span>Esta avaliação será arquivada automaticamente.</span>
          </div>
        </div>
        <div class="col-md-12 mt-3">
          <button class="btn btn-primary btn-rounded btn-block" (click)="onClickClosePricing()"
            [disabled]="loading || !isPriceReady() || !destination.valid || (showPricingTypeSelector() && pricingType.invalid)"
            [ngClass]="{ loading: loading }">
            <div class="btn-spinner float-left" *ngIf="loading"></div>
              <span>{{ getClosePricingButtonLabel() | uppercase }} </span>     
          </button>
        </div>
        <div class="col-md-12 mt-3" *ngIf="canReturnToEvaluator()">
          <button class="btn btn-outline-primary btn-rounded btn-block" type="button" (click)="onClickGiveBack()">
            <i class="fa-solid fa-arrow-left-long mr-3"></i>
            <span>DEVOLVER CAPTAÇÃO</span>
          </button>
        </div>
      </div>

      <div class="lines-info py-16" *ngIf="revisionEstimated > 0">
        <div class="label px-0">
          <i class="material-icons">settings</i>
          <span>REVISÃO ESTIMADA</span>
          <div class="label-description px-0 float-right">
            R$ {{ revisionEstimated | number: "1.0-0" }}
          </div>  
        </div>
      </div>

      <div class="py-16">
        <div class="label"  *ngIf="vehicle.finalEvalScore">
          <i class="material-icons">star</i>
          <span>CLASSIFICAÇÃO</span>
          <div class="float-right label-description d-flex gap-1">
            {{ vehicle.useEvalScoreABC ? vehicle.finalEvalScoreABC : (vehicle.finalEvalScore | number) }}
            <div class="tooltip-lens" *ngIf="commentGiveBack.hasError('required')">
              <i class="material-icons ok-icon" *ngIf="isOKFinalScore()">check_circle</i>
              <i class="material-icons warning-icon" *ngIf="isWarningFinalScore()">warning</i>
              <i class="material-icons danger-icon" *ngIf="isDangerFinalScore()">error</i>
            </div>
          </div>
        </div>
      </div>

      <div class="card-footer" *ngIf="vehicle.status === 'PRICING' && showFooter && showGiveBack">
        <ng-container *ngIf="showGiveBack">
          <div class="tooltip-lens" *ngIf="commentGiveBack.hasError('required')">
            <div class="ballon">
              <div class="wrapper-content">
                <p class="text-danger">
                  Informe o motivo da devolução para o avaliador.
                </p>
              </div>
            </div>
          </div>
          <textarea [formControl]="commentGiveBack" autofocus placeholder="O QUE FALTOU NA CAPTAÇÃO?" class="form-control"
            rows="10" style="resize: none;"></textarea>
          <button class="btn btn-danger btn-rounded btn-block" (click)="onClickSendBackToEvaluator()"
            [disabled]="loading || !commentGiveBack.valid" [ngClass]="{ loading: loading }">
            <div class="btn-spinner float-left" *ngIf="loading"></div>
            <span>
              DEVOLVER PARA O AVALIADOR
            </span>
          </button>
          <button class="d-block cancel" (click)="onClickGiveBack()">
            CANCELAR
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</div>